//@ts-nocheck
import {
  Accounts,
  Applications,
  CivilRegistry,
  Collaterals,
  CustomFields,
  Entries,
  Files,
  Loans,
  Notes,
  Relationships,
  Reports,
  Risks,
  CreditInfo,
  SMS,
  SomeOther,
  Monitoring,
  PhysicalFirst,
  PhysicalSecond,
  PhysicalThird,
} from './Tabs'

const config = {
  [PhysicalFirst.config.name]: PhysicalFirst.config,
  [PhysicalSecond.config.name]: PhysicalSecond.config,
  [PhysicalThird.config.name]: PhysicalThird.config,
  [CustomFields.config.name]: CustomFields.config,
  [Applications.config.name]: Applications.config,
  [Loans.config.name]: Loans.config,
  [Collaterals.config.name]: Collaterals.config,
  [Monitoring.config.name]: Monitoring.config,
  [Notes.config.name]: Notes.config,
  [CivilRegistry.config.name]: CivilRegistry.config,
  [Risks.config.name]: Risks.config,
  [CreditInfo.config.name]: CreditInfo.config,
  [Relationships.config.name]: Relationships.config,
  [SMS.config.name]: SMS.config,
  [Files.config.name]: Files.config,
  [Accounts.config.name]: Accounts.config,
  [Entries.config.name]: Entries.config,
  [Reports.config.name]: Reports.config,
  [SomeOther.config.name]: SomeOther.config,
}

export default config